import { faLink, faUsers } from '@fortawesome/free-solid-svg-icons';
import { faArrowRightLong } from '@fortawesome/pro-light-svg-icons';
import { faFolderGear, faInputText, faObjectUnion } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Grid from 'Components/Atoms/Grid/Grid';
import IconWrapper from 'Components/Atoms/IconWrapper/IconWrapper';
import Text from 'Components/Atoms/Text/Text';
import Title from 'Components/Atoms/Title/Title';
import Card from 'Components/Molecules/Card/Card';
import TitleGroup from 'Components/Molecules/TitleGroup/TitleGroup';
import SettingsTemplate from 'Components/Templates/Page/Settings/SettingsTemplate';
import { Link } from 'react-router-dom';
import { ROUTES } from 'Services/Route/Route.types';

const SettingsMenu: any = {
    Systeem: [{
        path: ROUTES.SETTINGS.ENTITIES.getFullPath(),
        icon: faObjectUnion,
        title: 'Entiteiten',
        description: 'Ga door naar de instellingen van entiteiten'
    }, {
        path: ROUTES.SETTINGS.EXTENSIONS.getFullPath(),
        icon: faFolderGear,
        title: 'Extensies',
        description: 'Ga door naar de instellingen van extensies'
    }, {
        path: ROUTES.SETTINGS.USERS.getFullPath(),
        icon: faUsers,
        title: 'Gebruikers',
        description: 'Ga door naar de instellingen van gebruikers'
    }],

    Data: [{
        path: ROUTES.SETTINGS.RELATIONS.getFullPath(),
        icon: faLink,
        title: 'Relaties',
        description: 'Ga door naar de instellingen van relaties'
    }, {
        path: ROUTES.SETTINGS.DATASETS.getFullPath(),
        icon: faInputText,
        title: 'Datasets',
        description: 'Ga door naar de instellingen van datasets'
    }]
}

const SettingsPage = ({
    ...props
}: any) => {
    return <SettingsTemplate>
        <Grid axis='vertical'>
            {
                Object.keys(SettingsMenu).map((key: any, idx: number) => <>
                    <Title
                        size='small'
                        weight='semibold'
                        margin={idx === 0 ? 'none' : 'top'}
                    >
                        {key}
                    </Title>
                    {
                        SettingsMenu[key].map(i =>
                            <Link to={i.path} style={{textDecoration: 'none'}} data-cy="settings-item">
                                <Card axis="horizontal" state="link">
                                    <TitleGroup iconBefore={
                                        <IconWrapper>
                                            <FontAwesomeIcon icon={i.icon} size="2x" />
                                        </IconWrapper>
                                    }>
                                        <Title
                                            size="inherit"
                                            transform='uppercase'
                                            weight='bold'
                                        >
                                            { i.title }
                                        </Title>
                                        <Text color='secondary'>{i.description}</Text>
                                    </TitleGroup>
                                    <FontAwesomeIcon icon={faArrowRightLong} size='2x' color='#757575' />
                                </Card>
                            </Link>
                        )
                    }
                </>)
            }
        </Grid>
    </SettingsTemplate>
}

export default SettingsPage;